<template>
  <!-- 树形组件 -->
  <div class="hb-tree">
    <div class="hb-tree__title" v-if="title != ''">{{ title }}</div>
    <div class="hb-tree__operating">
      <img class="tree-view--optbtn" src="static/img/tree-add.png" />
      <img class="tree-view--optbtn" src="static/img/tree-edit.png" />
      <img
        class="tree-view--optbtn"
        style="margin-right: 0px;"
        src="static/img/tree-del.png"
      />
      <!-- <img class="tree-view--optbtn" src="static/img/tree-add.png" @click="addBrand()" alt="" />
			<img class="tree-view--optbtn" src="static/img/tree-edit.png" @click="updateBrand()" alt="" v-if="brandList.length > 0" />
			<img class="tree-view--optbtn" style="margin-right: 0px;" src="static/img/tree-del.png" @click="delbrand()" alt="" v-if="brandList.length>0"/> -->
    </div>
    <div class="hb-tree-view">
      <el-tree
        :data="data"
        :props="defaultProps"
        accordion
        @node-click="handleNodeClick"
      ></el-tree>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [
        {
          label: "吉林省",
          children: [
            {
              label: "长春市",
              children: [
                {
                  label: "吉林大学",
                  children: [
                    {
                      label: "吉林大学吉林大学吉林大学",
                      children: [
                        {
                          label: "吉林大学吉林大学"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          label: "辽宁省",
          children: [
            {
              label: "沈阳市",
              children: [
                {
                  label: "辽宁中医药大学"
                }
              ]
            },
            {
              label: "大连市",
              children: [
                {
                  label: "大连工业大学"
                }
              ]
            }
          ]
        },
        {
          label: "黑龙江省",
          children: [
            {
              label: "哈尔滨市",
              children: []
            }
          ]
        }
      ],
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  props: {
    title: {
      type: String,
      default: ""
    }
    // data: {
    // 	type: Object,
    // 	default: function() {
    // 		return []
    // 	}
    // }
  },
  methods: {
    chanage() {},
    handleNodeClick(data) {
      console.log(data);
    }
  }
};
</script>

<style lang="stylus">
.hb-tree
	height 100%
	width 100%
	padding 20px
	display flex
	flex-direction column
	font-family Microsoft YaHei
	font-weight 400
	.hb-tree__title
		height 26px
		font-size 22px
		color #2B2F3F
		line-height 26px
		padding-left 20px
		border-left 4px solid #084FF7
		margin-bottom 30px
	.hb-tree__operating
		height 50px
		margin-bottom 30px
		display flex
		flex-direction row
		justify-content flex-start
	.hb-tree-view
		flex 1
		.hb-tree-node
			display flex
			flex-direction column
			cursor pointer
			.hb-tree-node__content
				height 30px
				display flex
				flex-direction row
				align-items center
				&:hover
					background-color #EFEFEF
			.hb-tree-node__icon
				height 30px
				width 30px
				display flex
				flex-direction row
				align-items center
				justify-content center
				font-size 10px
			.hb-tree-node__label
				flex 1
		.el-tree-node__children
			display flex
			flex-direction column
			cursor pointer
			.hb-tree-node__content
				padding-left 30px
.tree-view--title
	height 26px
	font-size 22px
	color #2B2F3F
	line-height 26px
	padding-left 20px
	border-left 4px solid #084FF7
	margin-bottom 36px
.tree-view--opt
	height 50px
	margin-bottom 36px
	display flex
	flex-direction row
	justify-content flex-start
.tree-view--optbtn
	height 49px
	width 49px
	margin-right 30px
	cursor pointer
.tree-view--list
	display flex
	flex-direction column
.tree-view--list-item
	height 16px
	color #222738
	line-height 16px
	margin-bottom 10px
	cursor pointer
	padding 10px
	height 36px
	border-radius 2px
.tree-item-active
	color #3B5EFF
	background-color #efefef
.tree-view--list
	display flex
	flex-direction column
.tree-view--title
	height 26px
	font-size 22px
	color #2B2F3F
	line-height 26px
	padding-left 20px
	border-left 4px solid #084FF7
	margin-bottom 36px
.tree-view--opt
	height 50px
	margin-bottom 36px
	display flex
	flex-direction row
	justify-content flex-start
.tree-view--optbtn
	height 49px
	width 49px
	margin-right 30px
	cursor pointer
.tree-view--list
	display flex
	flex-direction column
.tree-view--list-item
	height 16px
	color #222738
	line-height 16px
	margin-bottom 10px
	cursor pointer
	padding 10px
	height 36px
	border-radius 2px
.tree-item-active
	color #3B5EFF
	background-color #efefef
.tree-view--list
	display flex
	flex-direction column
</style>



// WEBPACK FOOTER //
// src/components/parts/hbTree.vue